module.exports = __webpack_public_path__ + "static/4-1a7c9eae7b0f39aa418d2b39d43ccb4c.jpg";